import React, { useEffect, useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Nav from './components/Nav.jsx';
import Footer from './components/Footer.jsx';
import StartScreen from './components/StartScreen.jsx';
import Quiz from './components/Quiz.jsx';
import HighScores from './components/HighScores.jsx';

export default function App() {
  const [dark, setDark] = useState(() => localStorage.getItem('theme') === 'dark');
  const { pathname } = useLocation();

  useEffect(() => {
    document.body.classList.toggle('dark', dark);
    document.documentElement.classList.toggle('dark', dark);
    localStorage.setItem('theme', dark ? 'dark' : 'light');
  }, [dark]);

  const mainClass = pathname === '/' ? 'app-main app-main--center' : 'app-main';

  return (
    <div className="app-shell">
      <Nav dark={dark} setDark={setDark} />
      <main className={mainClass}>
        <Routes>
          <Route path="/" element={<StartScreen />} />
          <Route path="/quiz" element={<Quiz />} />
          <Route path="/highscores" element={<HighScores />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}
